import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DefaultEditor from "react-simple-wysiwyg";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import {
  addEditTemplate,
  fetchProfile,
} from "../../../core/data/redux/slices/ProfileSlice";

const EmailTemplateOffcanvas = ({ onSaveOffCanvas }) => {
  const [formData, setFormData] = useState({
    emailTemplate_id: "",
    emailTemplateTitle: "",
    emailTemplateSubject: "",
    emailTemplateBody: "",
  });
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["blockquote", "code-block"],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "align",
    "blockquote",
    "code-block",
    "link",
    "image",
  ];
  const dispatch = useDispatch();
  const quillRef = useRef(null);
  const handleInputChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleAddEmailTemplate = async (e) => {
    e.preventDefault();

    const templateData = {
      templateType: "email",
      ...(formData.emailTemplate_id && {
        template_id: formData.emailTemplate_id,
      }),
      emailTemplateTitle: formData.emailTemplateTitle,
      emailTemplateSubject: formData.emailTemplateSubject,
      emailTemplateBody: formData.emailTemplateBody,
    };

    try {
      await dispatch(addEditTemplate(templateData)).unwrap();
      onSaveOffCanvas();

      // Refetch templates to get updated list and reset email pagination
      const filters = {
        whatsappTemplatePage: 1,
        whatsappTemplateLimit: 10,
        emailTemplatePage: 1, // Reset to first page to see new template
        emailTemplateLimit: 10,
      };
      dispatch(fetchProfile(filters));

      document.getElementById("closeEmailTemplateOffcanvas")?.click();

      if (selectedTemplate.emailTemplate_id == "") {
        setFormData({
          emailTemplate_id: "",
          emailTemplateTitle: "",
          emailTemplateSubject: "",
          emailTemplateBody: "",
        });
      }
    } catch (error) {
      console.error("Error saving email template:", error);
    }
  };
  const selectedTemplate = useSelector((state) => state.selectedTemplate);

  useEffect(() => {
    if (selectedTemplate) {
      setFormData({
        emailTemplate_id: selectedTemplate.emailTemplate_id
          ? selectedTemplate.emailTemplate_id
          : "",
        emailTemplateTitle: selectedTemplate.emailTemplateTitle
          ? selectedTemplate.emailTemplateTitle
          : "",
        emailTemplateSubject: selectedTemplate.emailTemplateSubject
          ? selectedTemplate.emailTemplateSubject
          : "",
        emailTemplateBody: selectedTemplate.emailTemplateBody
          ? selectedTemplate.emailTemplateBody
          : "",
      });
    }
  }, [selectedTemplate]);
  const insertTag = (tag) => {
    const editor = quillRef.current?.getEditor(); // get Quill instance
    if (editor) {
      const range = editor.getSelection(); // current cursor location
      if (range) {
        editor.insertText(range.index, tag);
        editor.setSelection(range.index + tag.length); // move cursor
      }
    }
  };

  return (
    <div
      className="offcanvas offcanvas-end offcanvas-large"
      tabIndex={-1}
      id="email_template_offcanvas"
    >
      <div className="offcanvas-header border-bottom">
        <h5 className="fw-semibold">
          {selectedTemplate.emailTemplate_id !== ""
            ? "Edit Template"
            : "Add Template"}
        </h5>
        <button
          type="button"
          className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          id="closeEmailTemplateOffcanvas"
        >
          <i className="ti ti-x" />
        </button>
      </div>
      <div className="offcanvas-body">
        <form onSubmit={handleAddEmailTemplate}>
          <div className="row">
            <div className="col-12">
              <div className="mb-3">
                <label className="col-form-label">Title</label>
                <input
                  type="text"
                  value={formData.emailTemplateTitle}
                  name="emailTemplateTitle"
                  onChange={(e) =>
                    handleInputChange(e.target.name, e.target.value)
                  }
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-12">
              <div className="mb-3">
                <label className="col-form-label">Subject</label>
                <input
                  type="text"
                  value={formData.emailTemplateSubject}
                  name="emailTemplateSubject"
                  onChange={(e) =>
                    handleInputChange(e.target.name, e.target.value)
                  }
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-12">
              <label className="col-form-label">Attributes</label>
              <select
                className="form-select"
                aria-label="Default select example"
                onChange={(e) => {
                  if (e.target.value) insertTag(e.target.value);
                  e.target.selectedIndex = 0; // reset dropdown
                }}
              >
                <option value="">Insert Tag</option>
                <option value="{{firstName}}">First Name</option>
                <option value="{{lastName}}">Last Name</option>
                <option value="{{designation}}">Designation</option>
                <option value="{{email}}">Email</option>
              </select>
            </div>
            <div className="col-12">
              <div className="mb-3 mt-3">
                <label className="col-form-label">Body</label>
                {/* <DefaultEditor
                  name="emailTemplateBody"
                  placeholder="Enter text here"
                  value={formData.emailTemplateBody}
                  onChange={(e) => {
                    handleInputChange(e.target.name, e.target.value);
                  }}
                  style={{ minHeight: "300px" }}
                /> */}
                <ReactQuill
                  ref={quillRef}
                  theme="snow"
                  value={formData.emailTemplateBody}
                  onChange={(value) =>
                    handleInputChange("emailTemplateBody", value)
                  }
                  name="emailTemplateBody"
                  className="form-control my-quill"
                  placeholder="Enter text here"
                  modules={modules}
                  formats={formats}
                  style={{
                    height: "300px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                />
                {/* <textarea
                      rows={5}
                      cols={5}
                      className="form-control"
                       name="emailTemplateBody"
                      placeholder="Enter text here"
                        onChange={(e) =>
                    handleInputChange(e.target.name, e.target.value)
                  }
                      value={formData.emailTemplateBody}
                    /> */}
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-end">
            <button
              type="button"
              data-bs-dismiss="offcanvas"
              className="btn btn-light me-2"
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              {selectedTemplate?.emailTemplate_id == "" ? "Create" : "Update"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailTemplateOffcanvas;
